import { FC } from 'react';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { StatusCellViewModel } from './viewModel';
import { Box } from '@mui/material';
import { ReceiptStatusIcon } from '../../../../../lib/components/compound/dataDisplay/receiptStatusIcon';
import { TooltipComponent } from '../../../../../lib/components/atomic/feedback';

type StatusCellProps = GridRenderCellParams<StatusCellViewModel>;

export const StatusCell: FC<StatusCellProps> = ({ value: viewModel }) => {
  return viewModel ? (
    <TooltipComponent title={viewModel.title ?? ''} arrow placement="right">
      <Box height="fit-content" width="fit-content">
        <ReceiptStatusIcon status={viewModel.cellValue} />
      </Box>
    </TooltipComponent>
  ) : (
    <></>
  );
};
